import {NgModule} from '@angular/core'
import {RouterModule, Routes} from '@angular/router'
import {IsLoggedInGuard} from './shared/guards/is-logged-in-guard.service'

const routes: Routes = [
  {
    path: '',
    canActivate: [IsLoggedInGuard],
    loadChildren:  () =>  import('./authenticated/authenticated.module').then(m => m.AuthenticatedModule)
  },
  {
    path: 'login',
    loadChildren:  () =>  import('./login/login.module').then(m => m.LoginModule)
  },
  { path: '**', redirectTo: '/' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking',
    enableTracing: false,
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: 'top',
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
